"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetcher = void 0;
class Fetcher {
    constructor() {
        this.handlers = {};
        this.register("http", httpHandler);
        this.register("https", httpHandler);
    }
    get knownProtocols() {
        return Object.keys(this.handlers);
    }
    fetch(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const handler = this.handlers[url.protocol];
            if (handler === undefined) {
                throw new Error([
                    `I can not handle protocol: ${JSON.stringify(url.protocol)},`,
                    `  known protocols are: ${JSON.stringify(this.knownProtocols)}`,
                ].join("\n"));
            }
            return yield handler(url);
        });
    }
    register(protocol, handler) {
        if (!protocol.endsWith(":"))
            protocol += ":";
        this.handlers[protocol] = handler;
        return this;
    }
}
exports.Fetcher = Fetcher;
function httpHandler(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(url.href);
        return yield response.text();
    });
}
//# sourceMappingURL=Fetcher.js.map